import { queryOptions, useQuery } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import { getArtifact } from '@/services/artifacts/get-artifact';

export const ARTIFACT_QUERY_KEY = 'artifact';

export const artifactDetailQueryKey = (
  orgId: string | undefined,
  artifactId: string | null | undefined,
) => [ARTIFACT_QUERY_KEY, orgId, artifactId] as const;

export const artifactDetailQueryOptions = (
  orgId: string | undefined,
  artifactId: string | null | undefined,
) =>
  queryOptions({
    queryKey: artifactDetailQueryKey(orgId, artifactId),
    queryFn: () => getArtifact(orgId!, artifactId!),
    enabled: !!orgId && !!artifactId,
    staleTime: 30_000,
    retry: 1,
  });

export const useGetArtifact = (artifactId: string | null) => {
  const { currentOrg } = useOrgStore();
  return useQuery(artifactDetailQueryOptions(currentOrg?.orgid, artifactId));
};
